<script setup lang="ts">
const appMetadata = useAppMetadata()

const { buildId } = useRuntimeConfig().app

const { app } = useRuntimeConfig().public

const version = computed(() => app.version || buildId)

const newVersionExists = computed(() => !!appMetadata.value)

async function handleReload() {
  location.reload()
}
</script>

<template>
  <div>
    <p v-if="version" class="mt-5">
      Versjon: {{ version }}
    </p>
    <UButtonNew
      v-if="newVersionExists"
      class="mt-5"
      size="sm"
      theme="white"
      @click="handleReload"
    >
      <template #prepend>
        <u-icon name="download" size="sm" />
      </template>
      Hent nyeste versjon
    </UButtonNew>
  </div>
</template>
